import { useCallback, useEffect, useState } from "react";
import { API } from "@/lib/api";
import { SiteLogin } from "@/components/SiteLogin";

export const SiteGate = ({ children }) => {
  const [state, setState] = useState("checking");
  const check = useCallback(() => {
    fetch(`${API}/site-status`, { credentials: "include" })
      .then(async (r) => {
        if (!r.ok) return setState("locked");
        const d = await r.json();
        // A chat-only pass (embedded on an allowed website) opens just the embedded chat window.
        setState(d.scope === "embed" && !window.location.pathname.startsWith("/embed") ? "locked" : "open");
      })
      .catch(() => setState("locked"));
  }, []);
  useEffect(() => { check(); }, [check]);

  if (state === "open") return children;
  if (state === "checking") return <div data-testid="site-gate-checking" className="min-h-screen bg-white" />;
  return <SiteLogin onSuccess={check} />;
};
